import {InitPage} from "../../index";

declare var App: any;
declare var storeLocation: string;
declare var subZoneId: string;
declare var productionRunning: string;

export class ELCLiveEmployeeCount {
    elcLiveEmployeeChannel: any;

    constructor() {
        this.elcLiveEmployeeChannel = App.cable.subscriptions.create(
            {
              channel: "ELC::EmployeeReadChannel",
              tenant: storeLocation,
              sub_zone_id: subZoneId
            },
            {
              connected() { console.log("EmployeeLiveReadConnected") },
              disconnected() { /* Called when the subscription has been terminated by the server */ },
              received: (data: any) => this.updateStats(data)
            }
          );
    }

    updateStats(data) {
        console.log(data);
        $("#live_employee_head_count").text(data.employee_count);
    }
}

export function LoadPage() {
    InitPage("elc productions", () => {
        InitPage("cards index", () => {
            if(!productionRunning) {
                const c = new ELCLiveEmployeeCount();
            }
        });
    });
}
